import './index.css';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Navigation, EffectCoverflow, Pagination } from 'swiper/modules';
import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/effect-coverflow';
import { useState } from 'react';
import { Dialog, IconButton } from '@mui/material';
import { isMobileQuery } from '../../../utils/helpers';
import { useMediaQuery } from 'react-responsive';

const ImageSlider = ({ data }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedSlide, setSelectedSlide] = useState(null);
  const isMobile = useMediaQuery(isMobileQuery);

  const openPreview = (slide) => {
    setSelectedSlide(slide);
    setIsModalOpen(true);
  };

  const closePreview = () => {
    setSelectedSlide(null);
    setIsModalOpen(false);
  };

  return (
    <div className="w-full h-full flex items-center justify-center bg-black">
      <Swiper
        className="swiper-container w-full"
        effect="coverflow"
        grabCursor={true}
        centeredSlides={true}
        slidesPerView={1.3}
        loop={true}
        coverflowEffect={{
          rotate: 0,
          stretch: 0,
          depth: 100,
          modifier: 5,
        }}
        pagination={{ clickable: true }}
        // navigation
        modules={[EffectCoverflow, Pagination, Navigation]}
      >
        {data.map((item, index) => (
          <SwiperSlide key={index} onClick={() => openPreview(item)}>
            <div className="flex justify-center items-center w-full h-full">
              <img
                src={item.img}
                alt="slide_image"
                className="max-h-[400px] max-w-[90vw] md:max-w-[45vw] object-contain rounded-md"
              />
            </div>
          </SwiperSlide>
        ))}
      </Swiper>

      {isModalOpen && (
        <Dialog
          sx={{ zIndex: '100000' }}
          PaperProps={{ margin: isMobile ? '20px' : 'initial' }}
          open={isModalOpen}
          onClose={closePreview}
          maxWidth="lg"
          aria-labelledby="alert-dialog-title"
          aria-describedby="alert-dialog-description"
        >
          <IconButton
            onClick={closePreview}
            sx={{
              position: 'absolute',
              top: 8,
              right: 8,
              color: 'black',
              backgroundColor: 'white',
              border: '1px solid black',
              paddingInline: '10px',
              zIndex: 2,
            }}
          >
            <button className="leading-[1]" title="close">
              ✕
            </button>
          </IconButton>

          <div className="p-1 lg:p-6 bg-slate-200 overflow-visible">
            <div className="relative overflow-visible">
              <img
                className="rounded-[10px] inset-0 max-h-[70vh] max-w-full object-contain"
                src={selectedSlide.img}
                alt="Preview"
              />
            </div>
          </div>
        </Dialog>
      )}
    </div>
  );
};

export default ImageSlider;
